import styled from 'styled-components';
import { WorkflowContentBody, WorkflowContentFooter } from '../content/workflow-content.style';

export const WorkflowErrorBodyLayout = styled(WorkflowContentBody)`
  display: flex;
`;

export const WorkflowErrorFooterLayout = styled(WorkflowContentFooter)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;
